
export function openLiveChat() {
  const liveChat = window.LiveChatWidget;

  try {
    if (liveChat) {
      liveChat.get('state');
      liveChat.call('maximize');
    }
    else {
      throw("LiveChat not available");
    }
    
  } catch (error) {
    alert("Sorry, your browser is blocking the live chat. \nTry disabling your tracker blocker for this site or use another browser."); 
  }
}